import { useContext } from 'react';
import RootStore from '../stores/root-store';
import { StoreContext } from './store-provider';

export const useStore = (): RootStore => {
  return useContext(StoreContext);
};
